import {
  IS_PILOT,
  IS_MIMO,
  IS_LIGHT,
  IS_DJI_APP,
  IS_WECHAT,
  IS_MQQBROWSER,
  IS_WEIBO,
  IS_IOS,
} from '@/constants'
import {
  lightApp,
  djiApp,
  flyApp,
  mimoApp,
  wechat,
  weibo,
  qqBrowser,
} from '@/constants/platform';

export const getDevices = () => {
  let device = null, platform = null;
  switch (true) {
    case IS_IOS:
      device = 'IOS';
      break;
    default:
      device = 'Android';
      break;
  }

  switch (true) {
    case IS_LIGHT:
      platform = lightApp;
      break;
    case IS_PILOT:
      platform = flyApp;
      break;
    case IS_MIMO:
      platform = mimoApp;
      break;
    case IS_DJI_APP:
      platform = djiApp;
      break;
    case IS_WECHAT:
      platform = wechat;
      break;
    case IS_WEIBO:
      platform = weibo;
      break;
    case IS_MQQBROWSER:
      platform = qqBrowser;
      break;
    default:
      break;
  }

  return {
    device,
    platform,
  };
};
